import { Injectable, inject } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class VisitUserData<T = any> {
  private _api = inject(FsApi);


  public get(id: number, query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.get(
      `visitusers/${id}`,
      query,
      {
        key: 'visitUser',
        ...config,
      },
    );
  }

  public gets(query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.request(
      'GET',
      'visitusers',
      query,
      {
        key: 'visitUsers',
        ...config,
      },
    );
  }

  public export(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.get(
      'visitusers/export',
      data,
      {
        key: 'url',
        ...config,
      },
    );
  }

}
